import React from 'react'
import * as pt from 'prop-types'

// The "AD" rounded-rectangle symbol used in WCAG / W3C / NCAM materials to
// indicate audio-description availability. CC uses it wherever it needs a
// generic "audio description" affordance (the Quick Look launch button, the
// empty-state placeholders, etc.) instead of a generic speaker glyph.
//
// Inline SVG so it scales cleanly and inherits color from the surrounding
// text via `currentColor`. Pass a numeric or string `size` (CSS length).

const AudioDescriptionIcon = ({ size, color, style, title, ...rest }) => {
    const px = typeof size === 'number' ? size + 'px' : size
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 24"
            width={px}
            height={px}
            style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
            role={title ? 'img' : 'presentation'}
            aria-label={title}
            aria-hidden={title ? undefined : true}
            {...rest}
        >
            <rect
                x="1.5"
                y="1.5"
                width="29"
                height="21"
                rx="3"
                fill="none"
                stroke={color}
                strokeWidth="2.25"
            />
            <text
                x="16"
                y="17.5"
                textAnchor="middle"
                fontFamily="-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, sans-serif"
                fontSize="12.5"
                fontWeight="700"
                letterSpacing="0.5"
                fill={color}
            >AD</text>
        </svg>
    )
}

AudioDescriptionIcon.propTypes = {
    size: pt.oneOfType([pt.number, pt.string]),
    color: pt.string,
    style: pt.object,
    title: pt.string
}

AudioDescriptionIcon.defaultProps = {
    size: 24,
    color: 'currentColor'
}

export default AudioDescriptionIcon
